/* eslint-disable react/prop-types */
export const Tag = ({
  text = '',
  height = 20,
  color = '#AEE9D1',
  className = '',
}) => (
  <section
    className={className}
    style={{
      height: `${height}PX`,
      background: color,
      borderRadius: `${height / 2}PX`,
      fontSize: '13PX',
      padding: '0 8PX',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    {text}
  </section>
);
